import { Paper } from "@mui/material";

import React, { ReactNode } from "react";

type Props = {
  children?: ReactNode;
};

export default function CustomPaper({ children }: Props) {
  return (
    <Paper
      sx={{ margin:'0 20px 20px 20px', background:'none', padding:'20px' }}
    >
      {children}
    </Paper>
  );
}
